import styled from 'styled-components'

import { breakpoints } from '@themenu/design-system'

const LogoImageContainer = styled.div`
  height: 80px;
  width: 80px;
  margin: 0 auto;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
 `

export const MobileAppImage = () => (
  <picture>
    <source
      srcSet={`
        /images/mobile_app_icons_s.webp 300w,
        /images/mobile_app_icons_m.webp 600w,
        /images/mobile_app_icons_l.webp 1200w,
        /images/mobile_app_icons_xl.webp 2000w`}
      sizes={`${breakpoints.down('md')} 100vw, 50vw`}
      type="image/webp"
    />
    <img src={'/images/mobile_app_icons_xl.jpg'} alt="" />
  </picture>
)

export const SwileLogo = styled(() => (
  <LogoImageContainer>
    <picture>
      <source srcSet={'/images/logo_x1.webp 1x, /images/logo_x2.webp 2x'} type="image/webp" />
      <img src="/images/logo_x1.png" srcSet="/images/logo_x1.png, /images/logo_x2.png 2x" alt="" />
    </picture>
  </LogoImageContainer>
))``
